<template>
    <div class="overview">
        <v-row>
            <v-col>
                <v-card>
                    <v-tabs grow v-model="tab">
                        <v-tab v-for="(team, index) in $store.state.main.teams" :key="index">
                            <span v-if="team === 'Alle teams'">Alle</span>
                            <span v-else>{{ team.split(' ')[team.split(' ').length - 1] }}</span>
                        </v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col>
                <v-btn-toggle v-model="date" mandatory>
                    <v-btn value="yesterday">I går</v-btn>
                    <v-btn value="today">I dag</v-btn>
                </v-btn-toggle>
                <v-btn color="primary" class="white--text ml-4" depressed @click="getData">
                    <v-icon left>
                        fa-sync-alt
                    </v-icon>
                    Opdater data
                </v-btn>
            </v-col>
        </v-row>
        <loader v-if="loading" />
        <v-row v-else>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-subheader>
                            <v-row>
                                <v-col v-for="column in columns" :key="column.header" @click="setSort(column.field)" style="cursor: pointer">
                                    {{ column.header }}
                                    <v-icon v-if="sort.field === column.field && sort.order">fa-angle-down</v-icon>
                                    <v-icon v-else-if="sort.field === column.field">fa-angle-up</v-icon>
                                </v-col>
                            </v-row>
                        </v-subheader>
                        <v-list class="striped-list">
                            <v-list-item v-for="(agent, index) in sortedAgents" :key="index" @click="relog(agent)">
                                <v-list-item-content>
                                    <v-row>
                                        <v-col v-for="column in columns" :key="column.header">
                                            <span v-line-clamp="1">{{ column.formatter(agent[column.field]) }}</span>
                                        </v-col>
                                    </v-row>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>



<script>
export default {
    data () {
        return {
            date: 'today',
            view: 'teams',
            loading: true,
            agents: [],
            tab: 0,
            sort: {
                order: true,
                field: 'total'
            },
            columns: [
                {
                    header: 'Navn',
                    field: 'name',
                    formatter: v => v
                },
                {
                    header: 'Præmie total',
                    field: 'total',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Præmie emner',
                    field: 'leadTotal',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Præmie møder',
                    field: 'meetingTotal',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Afsluttede',
                    field: 'leadCount',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Ringetid',
                    field: 'effectiveDuration',
                    formatter: this.$options.filters.duration
                },
                {
                    header: 'Besvarelser',
                    field: 'responseCount',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'TMK',
                    field: 'TMK',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Bonus',
                    field: 'bonus',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Gennemgang',
                    field: 'examination',
                    formatter: this.$options.filters.separator
                }
            ]
        }
    },
    computed: {
        filteredAgents () {
            if (this.team === 'Alle teams') return this.agents
            else if (this.team === 'Tryg') return this.agents.filter(agent => agent.department === 'tryg')
            else if (this.team === 'Alka') return this.agents.filter(agent => agent.department === 'alka')
            else return this.agents.filter(agent => agent.team === this.team)
        },
		sortedAgents () {
			const order = this.sort.order ? -1 : 1;
            const agents = this.filteredAgents
			return agents.sort((a, b) => {
				return a[this.sort.field] > b[this.sort.field]
					? order
					: -order;
			})
        },
        team () {
            return this.$store.state.main.teams[this.tab]
        }
    },
    methods: {
        async getData () {
            this.loading = true
            let response = await this.$http().get(`/overview/${this.date}`)
            this.agents = response.data
            this.loading = false
        },
        relog (agent) {
            this.$store.dispatch('main/relog', agent)
            this.$store.dispatch('main/getConfig')
            this.$router.push({path: '/dashboard'})
        },
		setSort(field) {
			if (this.sort.field === field) this.sort.order = !this.sort.order;
			else
				this.sort = {
					field: field,
					order: true
				}
		}
    },
    watch: {
        date: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>

<style lang="scss">
.overview {
    .kpi {
    border-radius: 10px;
    padding: 15px 20px;
    text-align: center;
    font-weight: bold;
    font-size: 1.1rem;
    }
    .check {
        background: rgba(0, 255, 0, 0.4);
    }
    .progress {
        background: rgba(255, 255, 0, 0.4);
    }
    .none {
        background: rgba(255, 0, 0, 0.4);
    }
    .radios {
        &.v-input, &.v-input--selection-controls {
            margin-top: 0 !important;
            align-items: center;
        }
        .v-input__slot {
            margin: 0 !important;
        }
        .v-messages {
            display: none;
        }
    }
    .v-subheader {
        .col {
            padding-bottom: 0;
            padding-top: 0;
        }
    }
}
</style>